<template>
  <div id="CompanyId">
    <div  class="row" v-if="datum">
    <div id="logo" class="col-md-6 col-ms-12 center-text">
      <img 
        width="150"
        :src="getImagePath"
        :alt="companyalias"
        @error="setDefaultImage"

      />
    </div>
    <div id="title" class="col-md-6 col-ms-12 center-text">
        <br>
      <h2>{{ companyalias }}</h2>
      <b>Source of reviews: {{ revsiteid }}</b>
    </div>
    
  </div>
  <div v-else>No data!</div>
  </div>
</template>

<script>
export default {
  name: "CompanyId",
  props: ["datum",'companyalias','revsiteid'],
  computed: {
    getImagePath() {
      try{
        return require(`@/assets/img/${this.$route.params.companyalias}.png`);
      }
      catch{
        return  require('@/assets/img/Default.png');
      }
     
    },
  }
};
</script>
<style scoped>
#CompanyId {
  height: 220px;
  /* background-color: #f7bf5027; */
  display: flex;
  align-items: center;
}
#idcard #title b {
  color: gray;
  font-weight: 500;
}
</style>